export const fieldLabels = {
  title: "Qualification title",
  organisationReferenceNumber: "Organisation qualification reference",
  linkToSpecification: "Link to specification",
  qualLevel: "Qualification level",
  qualSubLevel: "Qualification sub-level",
  qualificationType: "Qualification type",
  epaStandardId: "Standard code",
  qualGLH: "GLH",
  qualTQT: "TQT",
  qualCredit: "Credit",
  qualSectorSubjectArea: "Sector subject area",
  overallGradingType: "Overall grading type",
  gradingScale: "Grading scale",
  qualAssessmentMethods: "Assessment methods",
  specialism: "Specialism",
  operationalStartDate: "Operational start date",
  qualificationReviewDate: "Qualification review date",
  operationalEndDate: "Operational end date",
  certificationEndDate: "Certification end date",
  offeredInEngland: "Offered in England",
  offeredInNorthernIreland: "Offered in Northern Ireland",
  preSixteen: "Pre 16",
  sixteenToEighteen: "16-18",
  eighteenPlus: "18+",
  nineteenPlus: "19+",
  fundingInEngland: "Intention to seek funding in England",
  fundingInNorthernIreland: "Intention to seek funding in Northern Ireland",
  isThisQualificationPrivate: "Is this qualification private?",
  optionalRoutesToCompleteQual: "Optional routes to complete qualification",
  offeredInternationally: "Currently offering and/or will consider offering internationally",
  niDiscountCode: "NI discount code",
  entitlementFrameworkDesignation: "Entitlement Framework (EF) Designation",
  gcseSizeEquivalence: "GCSE size equivalence",
  gceSizeEquivalence: "GCE size equivalence",
  approvedForDELFundedProgramme: "Approved for Department for the Economy funded programme"

}